// extracted by mini-css-extract-plugin
export default {"BodyContainer":"_BodyContainer--omYQu","BodyContainerText":"_BodyContainerText--IU9Wx","WarningIcon":"_WarningIcon--RsUrT"};